import { createContext, useContext, useReducer } from 'react';
import { UnidEntityCreateState, UnidEntityCreateReducer, ACTION_TYPES } from './unid-entity-create-reducer';
import { IUnidEntityAddRequest } from '../../../../model/scp/entity/request/unid-entity-add-request';

const UnidEntityCreateContext = createContext<UnidEntityCreateState | undefined>(undefined);
const UnidEntityCreateDispatchContext = createContext({} as any);

const UnidEntityCreateProvider = ({ children }: { children: React.ReactNode }) => {
    const initialState: UnidEntityCreateState = {
        request: {} as IUnidEntityAddRequest,
        showValidationErrors: false,
    };

    const [state, dispatch] = useReducer(UnidEntityCreateReducer, initialState);

    return (
        <UnidEntityCreateContext.Provider value={state}>
            <UnidEntityCreateDispatchContext.Provider value={dispatch}>
                {children}
            </UnidEntityCreateDispatchContext.Provider>
        </UnidEntityCreateContext.Provider>
    );
}

const useUnidEntityCreateState = () => {
    const context = useContext(UnidEntityCreateContext);
    if (context === undefined) {
        throw new Error('useUnidEntityCreateState must be used within a UnidEntityCreateProvider');
    }
    return context;
}

const useUnidEntityCreateDispatch = () => {
    const context = useContext(UnidEntityCreateDispatchContext);
    if (context === undefined) {
        throw new Error('useUnidEntityCreateDispatch must be used within a UnidEntityCreateProvider');
    }
    return context;
}

export { UnidEntityCreateProvider, useUnidEntityCreateDispatch, useUnidEntityCreateState, ACTION_TYPES };
